import { Text } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { PropsWithChildren } from "react";

interface Props extends PropsWithChildren {
  style?: "global/title-large" | "global/title-medium" | "global/title-small";
  actions?: React.ReactNode;
}

export function PageTitle(props: Props) {
  const { style = "global/title-medium" } = props;

  return (
    <div className={styles.wrapper}>
      <Text as="h1" style={style}>
        {props.children}
      </Text>
      {props.actions && <div>{props.actions} </div>}
    </div>
  );
}

const styles = {
  wrapper: css({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "start",
  }),
};
